import { MouseEvent } from 'react';
import cn from 'classnames';

import { DashbaordMyBizItem } from '@/api/pc-api/v1/mybiz/list/dashboard';
import Button from '@/components/common/Button';
import Tooltip from '@/components/Tooltip';
import { BIZ_TYPE, BizType } from '@/constants/bizType';
import { ROLE } from '@/constants/role';
import { getCompanyName, getDealerName } from '@/utils/myBiz';

type Props = {
  data: DashbaordMyBizItem;
  onClickMyBiz: (e: MouseEvent<HTMLAnchorElement>, myBiz: DashbaordMyBizItem) => void;
  onClickRegisterApp: (e: MouseEvent<HTMLButtonElement>, myBiz: DashbaordMyBizItem) => void;
};

const MyBizItem = ({ data, onClickMyBiz, onClickRegisterApp }: Props) => {
  const {
    authInfoId,
    needAppReg: isAppRegNeeded,
    partnerCompanyName,
    dealerCompanyName,
    bizType,
    bizTargetType,
    role
  } = data;
  const companyName = getCompanyName(partnerCompanyName, dealerCompanyName);
  const dealerName = getDealerName(bizTargetType, dealerCompanyName);

  return (
    <li key={authInfoId}>
      <a href="#none" className={cn('link_mybiz', { disabled: isAppRegNeeded })} onClick={(e) => onClickMyBiz(e, data)}>
        <span
          className={cn('ico_wallet', {
            ico_biz1: bizType === BizType.EDOC,
            ico_biz2: bizType === BizType.SET4,
            ico_biz3: bizType === BizType.MYDATA_CORP
          })}
        >
          {bizType}
        </span>
        <span className="item_mybiz">
          <strong className="tit_mybiz">
            {companyName} ({BIZ_TYPE[bizType]})
          </strong>
          <span className="area_info">
            <span className="txt_authority">{ROLE[role]}</span>
            {dealerName && <span className="txt_dealer">{dealerName}</span>}
          </span>
        </span>
        {isAppRegNeeded && (
          <Tooltip.Wrapper type="center">
            <Button size="m" variant="secondary01" onClick={(e) => onClickRegisterApp(e, data)}>
              <span className="ico_wallet ico_bang"></span>
              <span className="txt_btn">앱 정보 등록 필요</span>
            </Button>
            <Tooltip.Box>
              <div className="txt_tooltip">
                - 이용기관 등록 완료를 위해 디벨로퍼스 앱 정보 입력이 필요한 상태입니다.
                <br />- 앱 정보 입력을 위한 서비스 앱 정보 등록 페이지로 이동합니다.
              </div>
            </Tooltip.Box>
          </Tooltip.Wrapper>
        )}
        <span className="ico_wallet ico_arr_r_24">페이지이동</span>
      </a>
    </li>
  );
};

export default MyBizItem;
